module.exports = __webpack_public_path__ + "static/media/icon-file-pdf.86cc1f5a.svg";